import React from 'react';
import { NativeStackScreenProps } from '@react-navigation/native-stack';

import { useAppSelector } from '@app/store/hooks';
import { getCurrentUserId } from '@app/services/featureFlag';
import { PrivateStackParamList } from '@app/navigationApp/types';
import ChooseLimitV1 from '@screens/ChooseLimit/ChooseLimitV1';
import ChooseLimitV2 from '@screens/ChooseLimit/ChooseLimitV2';
import SetCreditLimit from '@screens/SetCreditLimit/SetCreditLimit';

type Props = NativeStackScreenProps<PrivateStackParamList, 'SET_CREDIT_LIMIT'>;

/**
 * A/B router for the credit-limit step. Reactively reads the `multi-offer`
 * variant from redux so it re-renders when flags are cleared or updated.
 */
const SetCreditLimitRouter = (props: Props) => {
  const featureFlags = useAppSelector((state) => state.featureFlags);
  const userId = getCurrentUserId();
  const variant =
    userId && featureFlags?.userId === userId
      ? featureFlags.variants['multi-offer']?.variantName ?? 'default'
      : 'default';

  switch (variant) {
    case 'VARIANT_A':
      return <ChooseLimitV1 {...props} />;
    case 'VARIANT_B':
      return <ChooseLimitV2 {...props} />;
    default:
      return <SetCreditLimit {...props} />;
  }
};

export default SetCreditLimitRouter;
